module.exports = {"513231100":"阿坝镇","513231101":"贾洛镇","513231102":"麦尔玛镇","513231103":"河支镇","513231104":"各莫镇","513231105":"安羌镇","513231201":"麦昆乡","513231203":"龙藏乡","513231204":"求吉玛乡","513231208":"四洼乡","513231209":"安斗乡","513231210":"柯河乡","513231211":"垮沙乡","513231213":"查理乡","513231214":"茸安乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513231.json
// module id = 2540
// module chunks = 0